class ParallaxImages extends HTMLElement {
  constructor() {
    super();
    this.parallaxInit = this.parallaxInit.bind(this);
    this.scrollAnimate = this.scrollAnimate.bind(this);
    // Store the container's position
    this.containerRect = null;

    console.log('ParallaxImages');
  }

  connectedCallback() {
    this.items = this.querySelectorAll('.parallaxe-image__item');

    window.addEventListener('scroll', this.parallaxInit);
    this.parallaxInit();

    document.addEventListener('shopify:section:load', this.parallaxInit);
  }

  disconnectedCallback() {
    console.log('ParallaxImages disconnectedCallback');
    window.removeEventListener('scroll', this.parallaxInit);
    document.removeEventListener('shopify:section:load', this.parallaxInit);
  }

  parallaxInit() {
    if (this.items.length) {
      // Get the container's position
      this.containerRect = this.getBoundingClientRect();
      this.scrollAnimate(this.items);
    }
  }

  scrollAnimate(parallaxItems) {
    for (let elem of parallaxItems) {
      let cHeight = document.documentElement.clientHeight;
      let cWidth = document.documentElement.clientWidth;

      let start = this.containerRect.top + pageYOffset - cHeight;
      let end = this.containerRect.bottom + pageYOffset;
      let percentScroll = parseInt(
        (pageYOffset - start) / ((end - start) / 100)
      );

      let propertyVal =
        -1.25 *
        ((parseInt(elem.dataset.speed || 0.5) / (cWidth > 750 ? 100 : 25)) *
          percentScroll);
      elem.style.transform = `translate3d(0px, ${propertyVal}px, 0px)`;
    }
  }
}

// Only define the custom element if it hasn't been defined yet
if (!customElements.get('parallax-images')) {
  customElements.define('parallax-images', ParallaxImages);
}
